import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as common from '../../../../../common'

export const DOC = gql`
  ${common.gql.flexibleIdentifier.fragments.DOC}
  ${common.gql.dms.data.fragments.variableValue.DOC}
  fragment FragmentMosaicWidgetRef on MosaicWidgetReference {
    identifier {
      ...FragmentFlexibleIdentifier
    }
    variables {
      ...FragmentVariableValue
    }
  }
`

export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentMosaicWidgetRefFragment,
  ents.core.mosaic.Widget.Ref
>({
  variables: common.gql.dms.data.fragments.variableValue.LOOKUP_TRANSFORMER,
  widget: {
    usingFullInput: graphql.transformers.OUT.validate(
      graphql.transformers.OUT.select<
        graphql.schema.FragmentMosaicWidgetRefFragment,
        ents.core.mosaic.Widget.Ref['widget'] | undefined,
        'identifier'
      >('identifier', common.gql.flexibleIdentifier.fragments.TRANSFORMER),
      TypeAsserter.assertIsNotNullish,
    ),
  },
})
